import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguagePicker',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { locale, messages } = useI18n({ useScope: 'global' });

const current = computed(() => (messages.value as any)[locale.value]);

const changeLanguage = (key: string) => {
    locale.value = key;
    localStorage.setItem('language', key);
    emit('change');
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_menu, null, {
      activator: _withCtx(({ props }) => [
        _withDirectives(_createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
          innerHTML: current.value.flag,
          class: "flag-btn"
        }), null, 16 /* FULL_PROPS */, ["innerHTML"]), [
          [
            _directive_tooltip,
            _ctx.$t('langpicker.change'),
            void 0,
            { "bottom-center": true }
          ]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (lang, key) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: key,
                onClick: ($event: any) => (changeLanguage(key as string))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    rounded: "0",
                    size: "24",
                    innerHTML: lang.flag
                  }, null, 8 /* PROPS */, ["innerHTML"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(lang.name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})